module.exports = __webpack_public_path__ + "img/vegetable-green-beans-350x184.45dc361f.jpg";